var _path, _path2, _path3, _g, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTnc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0001 38.735H7.87305C7.01055 38.735 6.31055 38.035 6.31055 37.1725C6.31055 36.31 7.01055 35.61 7.87305 35.61H21.0001C21.8626 35.61 22.5626 36.31 22.5626 37.1725C22.5626 38.035 21.8626 38.735 21.0001 38.735Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.9814 18.5425H26.8564C25.9939 18.5425 25.2939 17.8425 25.2939 16.98C25.2939 16.1175 25.9939 15.4175 26.8564 15.4175H39.9814C40.8439 15.4175 41.5439 16.1175 41.5439 16.98C41.5439 17.8425 40.8439 18.5425 39.9814 18.5425Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1978_2933",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 10,
    width: 14,
    height: 14
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.25 10.4175H19.2204V23.3166H6.25V10.4175Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1978_2933)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7354 13.5416C10.8833 13.5416 9.375 15.0333 9.375 16.8687C9.375 18.702 10.8833 20.1916 12.7354 20.1916C14.5896 20.1916 16.0958 18.702 16.0958 16.8687C16.0958 15.0333 14.5896 13.5416 12.7354 13.5416ZM12.7354 23.3166C9.16042 23.3166 6.25 20.425 6.25 16.8687C6.25 13.3125 9.16042 10.4166 12.7354 10.4166C16.3125 10.4166 19.2208 13.3125 19.2208 16.8687C19.2208 20.425 16.3125 23.3166 12.7354 23.3166Z",
    fill: "black"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.2248 33.7666C34.3706 33.7666 32.8623 35.2583 32.8623 37.0916C32.8623 38.927 34.3706 40.4166 36.2248 40.4166C38.0769 40.4166 39.5831 38.927 39.5831 37.0916C39.5831 35.2583 38.0769 33.7666 36.2248 33.7666ZM36.2248 43.5416C32.6477 43.5416 29.7373 40.6479 29.7373 37.0916C29.7373 33.5354 32.6477 30.6416 36.2248 30.6416C39.7998 30.6416 42.7081 33.5354 42.7081 37.0916C42.7081 40.6479 39.7998 43.5416 36.2248 43.5416Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTnc);
export default __webpack_public_path__ + "static/media/tnc.e38dce18aab1181795cf3ff9a2fca449.svg";
export { ForwardRef as ReactComponent };